import React, { useCallback } from 'react';
import { Route, Routes as ReactRoutes } from 'react-router-dom';
import EnhancedRoute from '../Enhanced';
import { EnhancedRouteProps } from '../Enhanced/Enhanced.route';

export type ComplexRoute = EnhancedRouteProps & {
  routes: ComplexRoute[];
};

type RoutesProps = {
  routes: ComplexRoute[];
};

const Routes: React.FC<RoutesProps> = ({ routes }) => {
  const calculateRoutes = useCallback(
    (routes: ComplexRoute[]) =>
      routes.map(({ path, index, routes, children, ...rest }, ind) => {
        if (index) {
          return (
            <Route key={ind} index element={<EnhancedRoute {...rest} />} />
          );
        }

        return (
          <Route key={ind} path={path} element={<EnhancedRoute {...rest} />}>
            {routes ? calculateRoutes(routes) : children}
          </Route>
        );
      }),
    []
  );

  return <ReactRoutes>{calculateRoutes(routes)}</ReactRoutes>;
};

export default Routes;
